<p-dialog [style]="{minWidth: '450px',width: '432px'}" [closeOnEscape]="false" [closable]="false" header="{{dialogTitle}}" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true" appendTo="body">
    <form class="validated-form mojo-admin-page" [formGroup]="form">
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div>
          <label>Profile Properties</label>
        </div>
        <div class="grid">
          <div class="col-2">
            <label for="name">Name</label>
          </div>
          <div class="col-10">
            <input name="name" id="name" pInputText placeholder="name" formControlName="name" />
            <div *ngIf="name.invalid && (name.dirty || name.touched)" class="alert-danger">
              <p *ngIf="name.errors.required">Name is required</p>
              <p *ngIf="name.errors.profileNameTaken">A profile with the name {{name.value}} already exists</p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!isNewProfile" class="mojo-profile-editor">
        <div>
          <label>Widget Selection</label>
        </div>
        <div>
          <label>Select which widgets are to be included on this profile:</label>
        </div>

        <div class="table-container">
            <p-table #table
                     responsiveLayout="scroll"
                     [paginator]="false"
                     [value]="widgetConfigurations"
                     datakey="id"
                     [(selection)]="selectedWidgetConfigs">
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 38px">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                  </th>
                  <th>Name</th>
                  <th>Category</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-widgetConfig>
                <tr [pSelectableRow]="widgetConfig">
                  <td><p-tableCheckbox [value]="widgetConfig"></p-tableCheckbox></td>
                  <td>{{widgetConfig.name}}</td>
                  <td>{{widgetConfig.type}}</td>
                </tr>
              </ng-template>
            </p-table>
        </div>

      </div>
    </form>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix admin-form">
      <button *ngIf="displayCreateCopyButton()" id="createcopy-button" type="button" [disabled]="!form.valid" pButton icon="fa-fw fa fa-copy" (click)="createCopy($event)" label="Create Copy"></button>
      <button *ngIf="displaySaveButton()" type="button" [disabled]="!allowActions || form.invalid" pButton icon="fa-fw fa fa-check" (click)="save()" label="Save"></button>
      <button type="button" [disabled]="!allowActions" pButton icon="fa-fw fa fa-close" (click)="cancel()" label="Cancel"></button>
      <button *ngIf="displayDeleteButton()" type="button" [disabled]="!allowActions || isNewProfile" pButton icon="fa-fw fa fa-trash-o" (click)="deleteProfile($event)" label="Delete"></button>
    </div>
  </p-footer>
</p-dialog>
